export interface TimePassedInStoreData {
    current: TimePassedInStoreDatas;
    versus: TimePassedInStoreDatas;
    comparison: Pick<TimePassedInStoreDatas, 'nbPerson'>;
}

export interface TimePassedInStoreDatas {
    nbPerson: number;
    averageTimePassed: number;
    timePassedByLevel: Record<string, number>;
}
